// state
import axios from "axios";
import commonservice from "../../shared/common.service";

const defaultState = () => ({
  entity: {
    id: null,
    notificationTypeId: null,
    title: null,
    message: null
  },
  notificationTypeList: []
});

const state = defaultState();
// getters
const getters = {};

// actions
const actions = {
  loadNotification({}, { pagination, search }) {
    return new Promise((resolve, reject) => {
      var param = {
        descending:
          pagination.sortDesc.length > 0 ? pagination.sortDesc[0] : false,
        page: pagination.page,
        rowsPerPage: pagination.itemsPerPage,
        sortBy: pagination.sortBy.length > 0 ? pagination.sortBy[0] : "name",
        search: search
      };
      axios
        .get("/notifications?" + commonservice.convertToQueryString(param))
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  setNotification({ commit }, { id }) {
    return new Promise((resolve, reject) => {
      axios
        .get("/notifications/" + id)
        .then(response => {
          commit("SET_NOTIFICATION", response.data);
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  saveNotification({ commit, state }) {
    return new Promise((resolve, reject) => {
      if (state.entity.id) {
        axios
          .patch("/notifications", state.entity)
          .then(response => {
            commit("RESET");
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      } else {
        axios
          .post("/notifications", state.entity)
          .then(response => {
            commit("RESET");
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      }
    });
  },
  deleteNotification({ commit }, { id }) {
    return new Promise((resolve, reject) => {
      axios
        .delete("/notifications/" + id)
        .then(response => {
          commit("RESET");
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  approveNotification({ commit }, { id }) {
    return new Promise((resolve, reject) => {
      axios
        .get("/approvenotification/" + id)
        .then(response => {
          commit("RESET");
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  initNotification({ commit }) {
    return new Promise((resolve, reject) => {
      axios
        .get("/list/notificationtype")
        .then(response => {
          commit("SET_NOTIFICATIONTYPE_LIST", response.data);
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  }
};

// mutations
const mutations = {
  RESET(state) {
    const notificationTypeList = state.notificationTypeList;
    Object.assign(state, defaultState());
    state.notificationTypeList = notificationTypeList;
  },
  SET_NOTIFICATION_DATA(state, data) {
    if (Object.prototype.toString.call(state[data.key]) === "[object Array]") {
      state[data.key][data.index][data.property] = data.value;
    } else if (
      Object.prototype.toString.call(state[data.key]) === "[object Object]"
    ) {
      state[data.key][data.property] = data.value;
    } else state.entity[data.key] = data.value;
  },
  SET_NOTIFICATION(state, data) {
    state.entity.id = data.id;
    state.entity.notificationTypeId = data.notificationTypeId;
    state.entity.title = data.title;
    state.entity.message = data.message;
  },
  SET_NOTIFICATIONTYPE_LIST(state, data) {
    state.notificationTypeList = data;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
